const props = {
  legendDisplay: {
  	type: Boolean,
  	default: true
  },

  legendName: {
  	type: String,
  },

  legendTransparency: {
  	type: Boolean,
  	default: false
  },

  legendCategory: {
  	type: String,
  	default: 'Layers'
  },

  legendToolTransparency: {
  	type: Boolean,
  	default: false
  }
}

const methods = {

}

export default {
	props,
	methods
}


// WEBPACK FOOTER //
// ./resources/js/map/MapComponents/mixins/legend/legend-layer.js